export const allArticles = [
    {
      title: "Scaling Cache with Redis",
      link: "https://medium.com/aws-tip/scaling-cache-with-redis-d97b384a67b0",
      date: "02/02/2023",
      platform: "Medium",
      publishedIn: "AWS Tip",
      thumbnail: "https://miro.medium.com/v2/resize:fit:1200/1*2oryUSp7GOFlCpQ3jyzzqQ.jpeg", // og:image [oai_citation:0‡awstip.com](https://awstip.com/scaling-cache-with-redis-ee749e1366e8)
      tags: ["System Design", "AWS"]
    },
    {
      title: "Building a YouTube AI Q&A Bot with Langchain, Llama, and Python",
      link: "https://medium.com/aws-tip/building-a-youtube-ai-q-a-bot-with-langchain-llama-and-python-1119bfc2994b",
      date: "10/21/2024",
      platform: "Medium",
      publishedIn: "AWS Tip",
      thumbnail: "https://miro.medium.com/v2/resize:fit:1200/1*9jkVZLvmHbAMIl7hbF3lFg.png", // og:image [oai_citation:1‡medium.com](https://medium.com/@asimhafeez/building-a-youtube-ai-q-a-bot-with-langchain-llama-and-python-1d3837a53453)
      tags: ["AI Engineering", "Machine Learning"]
    },
    {
      title: "How Vector Databases and Embeddings Power AI",
      link: "https://medium.com/aws-tip/how-vector-databases-and-embeddings-power-ai-3cf59f5c276e",
      date: "10/14/2024",
      platform: "Medium",
      publishedIn: "AWS Tip",
      thumbnail: "https://miro.medium.com/v2/resize:fit:1200/1*nUWL55uxpj-5fAuYkRDMbg.png", // og:image [oai_citation:2‡medium.com](https://medium.com/@asimhafeez/how-vector-databases-and-embeddings-power-ai-7cdd8664d84a)
      tags: ["AI Engineering", "Machine Learning"]
    },
    {
      title: "Introduction to Function Calling with LLMs",
      link: "https://medium.com/aws-tip/introduction-to-function-calling-with-llms-f8e97be4c539",
      date: "10/07/2024",
      platform: "Medium",
      publishedIn: "AWS Tip",
      thumbnail: "https://miro.medium.com/v2/resize:fit:1200/1*y2ds6NgK1ceNzuVusQrUWg.png", // og:image [oai_citation:3‡awstip.com](https://awstip.com/introduction-to-function-calling-with-llms-36692847bdd5)
      tags: ["AI Engineering", "Machine Learning"]
    },
    {
      title: "Build a RAG App with Langchain and Node.js: Chat with Your PDF",
      link: "https://medium.com/aws-tip/build-a-rag-app-with-langchain-and-node-js-chat-with-your-pdf-6b11a2155cae",
      date: "09/29/2024",
      platform: "Medium",
      publishedIn: "AWS Tip",
      thumbnail: "https://via.placeholder.com/400x250/1a1a1a/00D4FF?text=RAG+App", // article inaccessible; original placeholder retained
      tags: ["AI Engineering", "Machine Learning"]
    },
    {
      title: "Use Llama 3.1 as Your Private LLM",
      link: "https://medium.com/aws-tip/use-llama-3-1-as-your-private-llm-146b885c632b",
      date: "09/26/2024",
      platform: "Medium",
      publishedIn: "AWS Tip",
      thumbnail: "https://via.placeholder.com/400x250/1a1a1a/00D4FF?text=Llama+3.1", // article inaccessible; placeholder
      tags: ["AI Engineering", "Machine Learning"]
    },
    {
      title: "Use OpenAI with Node.js",
      link: "https://medium.com/aws-tip/use-openai-with-node-js-3b3c4e531cd3",
      date: "09/24/2024",
      platform: "Medium",
      publishedIn: "AWS Tip",
      thumbnail: "https://via.placeholder.com/400x250/1a1a1a/00D4FF?text=OpenAI+Node.js", // article inaccessible; placeholder
      tags: ["AI Engineering", "Machine Learning"]
    },
    {
      title: "What are Large Language Models (LLMs)? How do they work?",
      link: "https://medium.com/aws-tip/what-are-large-language-models-llms-how-do-they-work-83c0b31515b3",
      date: "09/19/2024",
      platform: "Medium",
      publishedIn: "AWS Tip",
      thumbnail: "https://via.placeholder.com/400x250/1a1a1a/00D4FF?text=LLMs+Explained", // article inaccessible; placeholder
      tags: ["AI Engineering", "Machine Learning"]
    },
    {
      title: "Configure and Implement AWS Cognito using Nestjs",
      link: "https://medium.com/aws-tip/configure-and-implement-aws-cognito-using-nestjs-6820484de8e5",
      date: "03/26/2024",
      platform: "Medium",
      publishedIn: "AWS Tip",
      thumbnail: "https://via.placeholder.com/400x250/1a1a1a/00D4FF?text=AWS+Cognito", // article inaccessible; placeholder
      tags: ["AWS", "System Design"]
    },
    {
      title: "Building Web Services with NestJS, TypeORM, and PostgreSQL",
      link: "https://medium.com/aws-tip/building-web-services-with-nestjs-typeorm-and-postgresql-8c3206a52a26",
      date: "02/26/2024",
      platform: "Medium",
      publishedIn: "AWS Tip",
      thumbnail: "https://miro.medium.com/v2/resize:fit:1200/1*Vg9i5WimG2JyaRh0oRJdhQ.png", // og:image [oai_citation:4‡awstip.com](https://awstip.com/building-web-services-with-nestjs-typeorm-and-postgresql-a9731f516782#:~:text=data,rh%3D%22true%22%20id%3D%22glyph_link%22%20rel%3D%22stylesheet)
      tags: ["System Design", "AWS"]
    },
    {
      title: "Use Nginx as a Load Balancer",
      link: "https://medium.com/aws-tip/use-nginx-as-a-load-balancer-b3a8f6817345",
      date: "12/30/2023",
      platform: "Medium",
      publishedIn: "AWS Tip",
      thumbnail: "https://miro.medium.com/v2/resize:fit:1200/1*H20kmSDpZY_XW2awsimPAA.png", // og:image [oai_citation:5‡awstip.com](https://awstip.com/use-nginx-as-a-load-balancer-204b5067aeec)
      tags: ["System Design", "AWS"]
    },
    {
      title: "Use Nginx as a Reverse Proxy",
      link: "https://medium.com/aws-tip/use-nginx-as-a-reverse-proxy-5f29c3c52f71",
      date: "11/11/2023",
      platform: "Medium",
      publishedIn: "AWS Tip",
      thumbnail: "https://miro.medium.com/v2/resize:fit:1200/1*ssGEj8AGUJloXQe21o4OgQ.png", // og:image [oai_citation:6‡awstip.com](https://awstip.com/use-nginx-as-a-reverse-proxy-c707b92df373#:~:text=rh%3D%22true%22%20property%3D%22og%3Aurl%22%20content%3D%22https%3A%2F%2Fawstip.com%2Fuse,rh%3D%22true%22%20rel%3D%22author%22%20href%3D%22https%3A%2F%2Fmedium.com%2F%40asimhafeez%22%3E%3Clink%20data)
      tags: ["System Design", "AWS"]
    },
    {
      title: "Building Powerful Search Features with AWS OpenSearch and Node.js",
      link: "https://medium.com/aws-tip/building-powerful-search-features-with-aws-opensearch-and-node-js-b49bc2440fe3",
      date: "11/04/2023",
      platform: "Medium",
      publishedIn: "AWS Tip",
      thumbnail: "https://miro.medium.com/v2/resize:fit:1200/1*5_BzQRndRLSxZHGI__1L2A.png", // og:image [oai_citation:7‡awstip.com](https://awstip.com/building-powerful-search-features-with-aws-opensearch-and-node-js-e369c77f722d#:~:text=many%20applications%20and%20websites,rh%3D%22true%22%20id%3D%22glyph_preload_link%22%20rel%3D%22preload%22%20as%3D%22style%22%20type%3D%22text%2Fcss)
      tags: ["AWS", "System Design"]
    },
    {
      title: "Nginx for Content Delivery: Setting Up a CDN",
      link: "https://medium.com/aws-tip/nginx-for-content-delivery-setting-up-a-cdn-ea5c0cfc45e4",
      date: "10/07/2023",
      platform: "Medium",
      publishedIn: "AWS Tip",
      thumbnail: "https://miro.medium.com/v2/resize:fit:1200/1*9bjXO4wTcPghF7YDzxbloQ.png", // og:image [oai_citation:8‡awstip.com](https://awstip.com/nginx-for-content-delivery-setting-up-a-cdn-6c38289eb086#:~:text=rh%3D%22true%22%20property%3D%22og%3Aurl%22%20content%3D%22https%3A%2F%2Fawstip.com%2Fnginx,rh%3D%22true%22%20rel%3D%22author)
      tags: ["System Design", "AWS"]
    },
    {
      title: "Use DynamoDB ACID Transactions",
      link: "https://medium.com/aws-tip/use-dynamodb-acid-transactions-2759f0e179ff",
      date: "09/28/2023",
      platform: "Medium",
      publishedIn: "AWS Tip",
      thumbnail: "https://via.placeholder.com/400x250/1a1a1a/00D4FF?text=DynamoDB+Transactions", // no accessible article; placeholder
      tags: ["AWS", "System Design"]
    },
    {
      title: "Efficient Multiplayer Game State Synchronization with Upstash Kafka and Node.js",
      link: "https://medium.com/aws-tip/efficient-multiplayer-game-state-synchronization-with-upstash-kafka-and-node-js-91c379e43b9f",
      date: "09/18/2023",
      platform: "Medium",
      publishedIn: "AWS Tip",
      thumbnail: "https://upstash.com/blog/kafka-gaming/opengraph-image?e98eef0666234d68", // og:image [oai_citation:9‡upstash.com](https://upstash.com/blog/kafka-gaming#:~:text=rel%3D%22canonical%22%20href%3D%22https%3A%2F%2Fupstash.com%2Fblog%2Fkafka,42372ed130431b0a.js%22%20nomodule%3D%22%22%3E%3C%2Fscript%3E%3Cscript%20id%3D%22ph_referral_track)
      tags: ["System Design", "AWS"]
    },
    {
      title: "The Ultimate Guide to Setting Up KrakenD API Gateway",
      link: "https://medium.com/aws-tip/the-ultimate-guide-to-setting-up-krakend-api-gateway-486a87869b76",
      date: "09/12/2023",
      platform: "Medium",
      publishedIn: "AWS Tip",
      thumbnail: "https://miro.medium.com/v2/resize:fit:1200/1*rMjvO5Lck7_UUPb2tdemlA.jpeg", // og:image [oai_citation:10‡awstip.com](https://awstip.com/the-ultimate-guide-to-setting-up-krakend-api-gateway-30fb0630fc9d#:~:text=bridge%E2%80%A6%22%3E%3Cmeta%20data,rh%3D%22true%22%20id%3D%22glyph_link%22%20rel%3D%22stylesheet%22%20type%3D%22text%2Fcss)
      tags: ["System Design", "AWS"]
    },
    {
      title: "IP, TCP, and HTTP Explained: Why do they matter?",
      link: "https://medium.com/aws-tip/ip-tcp-and-http-explained-why-do-they-matter-9f2f00b194e4",
      date: "09/02/2023",
      platform: "Medium",
      publishedIn: "AWS Tip",
      thumbnail: "https://miro.medium.com/v2/resize:fit:1200/1*KDdTdDFFlaP2kOfCAeKQ8Q.png", // og:image [oai_citation:11‡awstip.com](https://awstip.com/ip-tcp-and-http-explained-why-do-they-matter-9ada17e96000#:~:text=data,rh%3D%22true)
      tags: ["System Design"]
    },
    {
      title: "JWT Auth at Nginx",
      link: "https://medium.com/aws-tip/jwt-auth-at-nginx-dfb31b4ebf29",
      date: "08/22/2023",
      platform: "Medium",
      publishedIn: "AWS Tip",
      thumbnail: "https://miro.medium.com/v2/resize:fit:1200/1*BrBaeAgQfxyMxb5-vf-KRQ.png", // og:image [oai_citation:12‡awstip.com](https://awstip.com/jwt-auth-at-nginx-f09851675bae#:~:text=content%3D%22article%22%3E%3Cmeta%20data,auth)
      tags: ["System Design", "AWS"]
    },
    {
      title: "Node.js and DynamoDB: Mastering CRUD Operations for Beginners",
      link: "https://medium.com/aws-tip/node-js-and-dynamodb-mastering-crud-operations-for-beginners-b5e2b66c9fce",
      date: "08/10/2023",
      platform: "Medium",
      publishedIn: "AWS Tip",
      thumbnail: "https://miro.medium.com/v2/resize:fit:1200/1*HmJXAl_57zwLBXY650nCWw.png", // og:image [oai_citation:13‡awstip.com](https://awstip.com/node-js-and-dynamodb-mastering-crud-operations-for-beginners-404aefa60c38#:~:text=Delete%E2%80%8A%E2%80%94%E2%80%8Athe%20four%20main%20things%20you,rh%3D%22true)
      tags: ["AWS", "System Design"]
    },
    {
      title: "System Design: Software Architectures",
      link: "https://medium.com/aws-tip/system-design-software-architectures-c31b31306b9d",
      date: "08/03/2023",
      platform: "Medium",
      publishedIn: "AWS Tip",
      thumbnail: "https://miro.medium.com/v2/resize:fit:1200/1*zZzuIotAIMqrWJugitUQOA.png", // og:image [oai_citation:14‡medium.com](https://medium.com/@asimhafeez/system-design-software-architectures-f3f1ce9ecf4f#:~:text=property%3D%22og%3Atype%22%20content%3D%22article%22%3E%3Cmeta%20data,rh%3D%22true%22%20id%3D%22glyph_link%22%20rel%3D%22stylesheet)
      tags: ["System Design"]
    },
    {
      title: "Use Nginx as an API Gateway",
      link: "https://medium.com/aws-tip/use-nginx-as-an-api-gateway-320370df5a3a",
      date: "07/30/2023",
      platform: "Medium",
      publishedIn: "AWS Tip",
      thumbnail: "https://miro.medium.com/v2/resize:fit:1200/1*7wV2QUHzNNkWKyjmD4Hz0w.png", // og:image [oai_citation:15‡awstip.com](https://awstip.com/use-nginx-as-an-api-gateway-dbab6acf7870)
      tags: ["System Design", "AWS"]
    },
    {
      title: "Exploring Microservices: Developing a Currency Converter with Go and Node.js using gRPC",
      link: "https://medium.com/aws-tip/exploring-microservices-developing-a-currency-converter-with-go-and-node-js-using-grpc-2aa010d7cfa5",
      date: "07/26/2023",
      platform: "Medium",
      publishedIn: "AWS Tip",
      thumbnail: "https://miro.medium.com/v2/resize:fit:1200/1*ONAC7jqanOYYxLAcEzEIEg.png", // og:image [oai_citation:16‡awstip.com](https://awstip.com/exploring-microservices-developing-a-currency-converter-with-go-and-node-js-using-grpc-41d1ab767eb6#:~:text=content%3D%22gRPC%20is%20an%20open,rh%3D%22true)
      tags: ["System Design", "AWS"]
    },
    {
      title: "Real-Time Data Streaming with Apache Kafka and Node.js: A Complete Tutorial",
      link: "https://medium.com/aws-tip/real-time-data-streaming-with-apache-kafka-and-node-js-a-complete-tutorial-08b33d18547d",
      date: "04/27/2023",
      platform: "Medium",
      publishedIn: "AWS Tip",
      thumbnail: "https://miro.medium.com/v2/resize:fit:1200/1*_0maQ3c2_sOuDZZUkY8yUg.png", // og:image [oai_citation:17‡awstip.com](https://awstip.com/real-time-data-streaming-with-apache-kafka-and-node-js-a-complete-tutorial-3abbcda6af26)
      tags: ["System Design", "AWS"]
    },
    {
      title: "Blockchain Beyond Cryptocurrency: Use Cases",
      link: "https://medium.com/aws-tip/blockchain-beyond-cryptocurrency-use-cases-69f531055c8f",
      date: "04/08/2023",
      platform: "Medium",
      publishedIn: "AWS Tip",
      thumbnail: "https://miro.medium.com/v2/resize:fit:1200/1*WNySgNRRoYfCC1itxAs-qA.png", // og:image [oai_citation:18‡medium.com](https://medium.com/@asimhafeez/blockchain-beyond-cryptocurrency-use-cases-e6c3a94f678d)
      tags: ["Blockchain"]
    },
    {
      title: "Load Balancing Best Practices: Techniques Every Software Engineer Should Master",
      link: "https://medium.com/aws-tip/load-balancing-best-practices-techniques-every-software-engineer-should-master-67e53c8431a7",
      date: "03/16/2023",
      platform: "Medium",
      publishedIn: "AWS Tip",
      thumbnail: "https://miro.medium.com/v2/resize:fit:1200/1*SJjI-OrSR3jqWuXBXqd11Q.png", // og:image [oai_citation:19‡awstip.com](https://awstip.com/load-balancing-best-practices-techniques-every-software-engineer-should-know-5d067eda272b)
      tags: ["System Design", "AWS"]
    },
    {
      title: "Build a Scalable Backend Service with AWS: The Power of Serverless Architecture",
      link: "https://medium.com/aws-tip/build-a-scalable-backend-service-with-aws-the-power-of-serverless-architecture-87ac47a3a530",
      date: "03/05/2023",
      platform: "Medium",
      publishedIn: "AWS Tip",
      thumbnail: "https://miro.medium.com/v2/resize:fit:1200/1*F-IUgV_zmW9NFboup_-T9Q.png", // og:image [oai_citation:20‡awstip.com](https://awstip.com/build-a-scalable-backend-service-with-aws-the-power-of-serverless-architecture-9a2c1645e4ef)
      tags: ["AWS", "System Design"]
    },
    {
      title: "Upload Large files in chunks to AWS-S3 using Nodejs",
      link: "https://medium.com/aws-tip/upload-large-files-in-chunks-to-aws-s3-using-nodejs-1d0866bcb22c",
      date: "02/22/2023",
      platform: "Medium",
      publishedIn: "AWS Tip",
      thumbnail: "https://miro.medium.com/v2/resize:fit:1200/1*T_XMR7Ze2986tQIqh3cRPQ.png", // og:image [oai_citation:21‡awstip.com](https://awstip.com/upload-file-in-chunks-to-aws-s3-using-nodejs-1d0022681e1c)
      tags: ["AWS", "System Design"]
    },
    {
      title: "Amazon DynamoDB — Architecture and Features",
      link: "https://medium.com/aws-tip/amazon-dynamodb-architecture-and-features-9f8ae02d787e",
      date: "02/16/2023",
      platform: "Medium",
      publishedIn: "AWS Tip",
      thumbnail: "https://miro.medium.com/v2/resize:fit:1200/1*fLXwetY3A0SpT7ilwYdp6Q.png", // og:image [oai_citation:22‡awstip.com](https://awstip.com/amazon-dynamodb-architecture-and-features-e26c4bb2f6dd#:~:text=rh%3D%22true%22%20property%3D%22og%3Aurl%22%20content%3D%22https%3A%2F%2Fawstip.com%2Famazon,rh%3D%22true%22%20rel%3D%22author)
      tags: ["AWS", "System Design"]
    },
    {
      title: "Amazon DynamoDB — How it Reads/Writes Data Under the Hood",
      link: "https://medium.com/aws-tip/amazon-dynamodb-how-it-reads-writes-data-under-the-hood-10e1a41f1bbf",
      date: "02/06/2023",
      platform: "Medium",
      publishedIn: "AWS Tip",
      thumbnail: "https://miro.medium.com/v2/resize:fit:1200/1*oxZ-vWvKaoh-xrwdu-L-Cg.png", // og:image [oai_citation:23‡awstip.com](https://awstip.com/amazon-dynamodb-how-it-reads-writes-data-under-the-hood-faf32055363b#:~:text=data,writes)
      tags: ["AWS", "System Design"]
    },
    {
      title: "Caching Strategies and Eviction Policies with Redis",
      link: "https://medium.com/aws-tip/caching-strategies-and-eviction-policies-with-redis-49a85ff6f8c0",
      date: "01/02/2023",
      platform: "Medium",
      publishedIn: "AWS Tip",
      thumbnail: "https://miro.medium.com/v2/da:true/resize:fit:1200/0*iO6OE-xIhTacDqBz", // og:image [oai_citation:24‡awstip.com](https://awstip.com/caching-strategies-and-eviction-policies-with-redis-e5a6b50fd503#:~:text=application%E2%80%A6%22%3E%3Cmeta%20data,rh%3D%22true%22%20id%3D%22glyph_preload_link%22%20rel%3D%22preload%22%20as%3D%22style%22%20type%3D%22text%2Fcss)
      tags: ["System Design", "AWS"]
    },
    {
      title: "Redis and Its Data Structures",
      link: "https://medium.com/aws-tip/redis-and-its-data-structures-cb296f49d113",
      date: "12/10/2022",
      platform: "Medium",
      publishedIn: "AWS Tip",
      thumbnail: "https://miro.medium.com/v2/resize:fit:677/1*UAH15MVGkZtmMu34haAH1Q.png", // og:image [oai_citation:25‡awstip.com](https://awstip.com/redis-and-its-data-structures-820a6dc3185f#:~:text=content%3D%22article%22%3E%3Cmeta%20data,rh%3D%22true)
      tags: ["System Design", "AWS"]
    },
  ];